export const POPULATE_EDITORJS_INPUT_EVENT = "editorInput";

export function sendTextToEditor(text = "") {
  if (typeof document === "undefined") return;
  document.dispatchEvent(
    new CustomEvent(POPULATE_EDITORJS_INPUT_EVENT, { detail: { text } })
  );
}

// Type guard to check if an event is an EditorInputEvent
export function isEditorInputEvent(event: Event): event is CustomEvent<{ text: string }> {
  return event.type === POPULATE_EDITORJS_INPUT_EVENT;
}
